module.exports = __webpack_public_path__ + "static/media/phoneWhite.c0aab877.png";